import { useMutation, useQuery } from "@tanstack/react-query";
import { getAuthData } from "../../helper/getAuthData";
import AxiosConfig from "../../configurations/axiosConfig";

const endpoint = {
    wishlist: "wishlist",
}

export const useAddProductToWishlist = () => useMutation({
    mutationKey: ["addProductToWishlist"],
    mutationFn: async ({ ProductID }) => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "I",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
            ProductID: ProductID,
        }
        const response = await AxiosConfig.post(`${endpoint.wishlist}`, payload);
        return response?.data;
    }
})

export const useGetWishListProductData = () => useQuery({
    queryKey: ["getWishListProductData"],
    queryFn: async () => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "S",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
        }
        const response = await AxiosConfig.post(`${endpoint.wishlist}`, payload);
        return response?.data?.WishList || [];
    },
    enabled: !!getAuthData()?.AuthCode,
})

export const useRemoveProductFromWishlist = () => useMutation({
    mutationKey: ["removeProductFromWishlist"],
    mutationFn: async ({ WishID, ProductID }) => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "R",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
            WishID: WishID,
            ProductID: ProductID,
        }
        const response = await AxiosConfig.post(`${endpoint.wishlist}`, payload);
        return response?.data;
    }
});

export const useRemoveAllWishlistItems = () => useMutation({
    mutationKey: ["removeAllWishlistItems"],
    mutationFn: async () => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "RA",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
        }
        const response = await AxiosConfig.post(`${endpoint.wishlist}`, payload);
        return response?.data;
    }
})
